import AppLib from './AppLib'

const AppLibPlugin = {}

AppLibPlugin.install = function (Vue, options) {
  Vue.prototype.$_appLib = AppLib
}

export default AppLibPlugin
